module.exports = __webpack_public_path__ + "fonts/Lato-BoldItalic.9c7e4e9e.woff";